// Сессия и телеметрия онбординга: session id, отметка «просмотрен», таймаут
// неактивности, отправка событий. Выделено из onboarding.ts (аудит, этап 2).

const ONBOARDING_SEEN_KEY = 'ae3_onboarding_seen';
const ONBOARDING_SESSION_KEY = 'ae3_onboarding_session';
const ONBOARDING_LAST_ACTIVITY_KEY = 'ae3_onboarding_last_activity';

const DEFAULT_SESSION_TIMEOUT_MIN = 30;
let sessionTimeoutMin = DEFAULT_SESSION_TIMEOUT_MIN;

export function configureOnboardingSessionTimeout(minutes: number | undefined) {
  if (typeof minutes === 'number' && Number.isFinite(minutes) && minutes >= 5 && minutes <= 120) {
    sessionTimeoutMin = minutes;
  }
}

export function getOnboardingSessionTimeoutMin(): number {
  return sessionTimeoutMin;
}

export function touchOnboardingActivity() {
  try {
    sessionStorage.setItem(ONBOARDING_LAST_ACTIVITY_KEY, String(Date.now()));
  } catch {
    // ignore storage errors
  }
}

export function resetOnboardingSession() {
  try {
    sessionStorage.removeItem(ONBOARDING_SESSION_KEY);
    sessionStorage.removeItem(ONBOARDING_LAST_ACTIVITY_KEY);
  } catch {
    // ignore storage errors
  }
}

export function readLastActivityMs(): number | null {
  try {
    const raw = sessionStorage.getItem(ONBOARDING_LAST_ACTIVITY_KEY);
    if (!raw) return null;
    const parsed = Number.parseInt(raw, 10);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

function createSessionId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
    const rand = Math.floor(Math.random() * 16);
    const value = ch === 'x' ? rand : (rand & 0x3) | 0x8;
    return value.toString(16);
  });
}

export function getOnboardingSessionId(): string {
  try {
    const existing = sessionStorage.getItem(ONBOARDING_SESSION_KEY);
    if (existing) {
      touchOnboardingActivity();
      return existing;
    }
    const next = createSessionId();
    sessionStorage.setItem(ONBOARDING_SESSION_KEY, next);
    touchOnboardingActivity();
    return next;
  } catch {
    return createSessionId();
  }
}

export async function trackOnboardingEvent(payload: Record<string, unknown>): Promise<void> {
  try {
    await fetch('/api/journey/onboarding/event', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        session_id: getOnboardingSessionId(),
        ...payload,
      }),
      keepalive: true,
    });
  } catch {
    // Telemetry must not block UX.
  }
}

export function isOnboardingSeen(): boolean {
  return localStorage.getItem(ONBOARDING_SEEN_KEY) === '1';
}

export function markOnboardingSeen() {
  localStorage.setItem(ONBOARDING_SEEN_KEY, '1');
}

export function shouldShowOnboarding(): boolean {
  return !isOnboardingSeen();
}
